import { createSlice } from "@reduxjs/toolkit";
import { ITimeKeepingSummary } from "core/http/service/timeKeeping/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: ITimeKeepingSummary;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    compensatoryLeave: 0,
    goingLate: 0,
    leaveEarly: 0,
    noSalary: 0,
    paidLeave: 0,
    workDay: 0,
    regulationWorkDay: 0,
  },
};

const getTimeKeepingSummarySlice = createSlice({
  name: "getTimeKeepingSummary",
  initialState,
  reducers: {
    getTimeKeepingSummaryStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getTimeKeepingSummarySuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getTimeKeepingSummaryFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetTimeKeepingSummary: () => {
      return { ...initialState };
    },
  },
});

export const {
  getTimeKeepingSummaryStart,
  getTimeKeepingSummarySuccess,
  getTimeKeepingSummaryFailed,
  resetTimeKeepingSummary,
} = getTimeKeepingSummarySlice.actions;

export default getTimeKeepingSummarySlice.reducer;
